import * as React from "react";
import {ICustomerPortalService, NewCardForm, Types} from "@falcon/services";
import {authorize} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {CardForm} from "../../../../../components/payments/CardForm";
import {getSessionStorage, setSessionStorage} from "../../../../../CommonFunctions";

interface IProps {
    verifyNewCardFailed: boolean,
    product: string
    policyNumber?: string;
}

interface IState {
    newCardForm?: NewCardForm,
    policyNumber?: string
}

@authorize
export class OutstandingPaymentForm extends React.Component<IProps, IState> {
    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            newCardForm: undefined,
        };
    }

    public componentDidMount() {
        const product: string = this.props.product ? this.props.product : getSessionStorage("missedPaymentProduct");
        const policyNumber: string = this.props.policyNumber ? this.props.policyNumber : getSessionStorage("missedPaymentPolicyNumber");
        if (policyNumber) {
            this.customerPortalService.autNewCardOutstandingPaymentByPolicyNumber(product, policyNumber).subscribe((newCardForm: NewCardForm) => {
                this.setState({
                    newCardForm,
                    policyNumber
                })
                setSessionStorage("missedPaymentProduct", product);
                setSessionStorage("isChargeBack", true);
                setSessionStorage("missedPaymentPolicyNumber", policyNumber);
            });
        }
    }

    public render() {
        return (
            <CardForm newCardForm={this.state.newCardForm} verifyNewCardFailed={this.props.verifyNewCardFailed} policyNumber={this.state.policyNumber}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/missedPayment/OutstandingPaymentForm.tsx